import React, { useMemo } from 'react'
import EdgescanMappingForm from './EdgescanMappingForm';
import EdgescanCredentialsForm from './EdgescanCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import _ from 'lodash';
import ContentOverlay from 'components/ContentOverlay';
import { Typography, Popover, Tag } from 'antd';
import { CellRenderers } from 'utils/tableUtils';
import AssessmentContent from './AssessmentContent';

export default function EdgescanConfigListing(props) {

    const renderMetaDetail = (key, record) => {
        if(_.isNil(record.metaDetails)) return CellRenderers.VALUE_OR_NA();
        const assessmentDetails = JSON.parse(record.metaDetails).assetAssessmentDate;
        return _.isEmpty(assessmentDetails) ? CellRenderers.VALUE_OR_NA() : assessmentDetails.map(data => <p>{CellRenderers.TIME(data[key])}</p>)
    }

    const columns = useMemo(() => [{
        title: "Asset Name",
        dataIndex: "assetName",
        render: (assetName, record) => {
            const assetIds = _.split(record.assetId, ",");
            const assetNames = _.split(assetName, ",");
            const content = assetNames.map((item, i) => {
                    return (
                        <Popover align={{ offset: [0, 6]}} content ={<AssessmentContent toolName={props.name} loginId ={record.login_id} assetId={assetIds[i]} />}>
                            <Typography.Link
                                href={`/user/tools/generic/project/${props.name}/redirect?login_id=${record.login_id}&name=${assetIds[i]}`}
                                className='m-b-xs d-inline-block'
                                target='_blank'
                            >
                                {item}
                            </Typography.Link>
                        </Popover>
                    );
                })
            return <ContentOverlay content={content} minHeight={40} />;
        },
        width: 150
    },{
        title: "Asset Id",
        dataIndex: "assetId",
        render: assetId => assetId.split(',').map(id => <p><Tag>{id}</Tag></p>),
        width: 100
    }
], [props.name]);

const appendColumns = useMemo(() => (
    [
        {
            title: "Last DAST Scan",
            dataIndex: "lastDastScanDate",
            key: "lastDastScanDate",
            render: (__, record) => renderMetaDetail('lastDastScanDate', record),
            width: 150,
            showFilter: false,
            showSort: true
        },
        {
            title: "Next DAST Scan",
            dataIndex: "nextDastScanDate",
            key: "nextDastScanDate",
            render: (__, record) => renderMetaDetail('nextDastScanDate', record),
            width: 150,
            showFilter: false,
            showSort: true
        },
        {
            title: "Last Pen Test",
            dataIndex: "lastPenTestScanDate",
            key: "lastPenTestScanDate",
            render: (__, record) => renderMetaDetail('lastPenTestScanDate', record),
            width: 150,
            showFilter: false,
            showSort: true
        },
        {
            title: "Next Pen Test",
            dataIndex: "nextPenTestScanDate",
            key: "nextPenTestScanDate",
            render: (__, record) => renderMetaDetail('nextPenTestScanDate', record),
            width: 150,
            showFilter: false,
            showSort: true
        }
    ]
), [])

    

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={EdgescanMappingForm}
            CredentialsForm={EdgescanCredentialsForm}
            extraColumns={columns}
            appendColumns={appendColumns}
        />
    )
}